<!-- src/components/ui/AtlasTab.vue -->
<template>
  <v-tab v-bind="$attrs">
    <template
      v-for="(_, name) in $slots"
      #[name]="slotProps"
    >
      <slot
        :name="name"
        v-bind="slotProps ?? {}"
      />
    </template>
  </v-tab>
</template>

<script setup lang="ts">
defineOptions({ inheritAttrs: false })
</script>
